var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/user-over.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-d3e0f4d6!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/user-over.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/UserOver.vue
// module id = 755
// module chunks = 1